import { FbBetModel } from './FbBetModel';
import { FbPersonalTips } from './FbPersonalTips';
import { FbTipPrice } from './FbTipPrice';
import { FbTipsterInfo } from './FbTipsterInfo';
import { FbNotes } from './FbNotes';
export class FbPersonalTipsPackage extends FbPersonalTips {
  public packageTotalBetAmount: number;
  public aMatchNum: number[];
  public purchaseDate: string;
  public fbNotes: FbNotes;
  public buyerCount: number;
  public addCommentEnabled: boolean;
  public lastMatchNum: number;
  public lastMatchDate: string;
  public lastMatchStartTime: string;
  public lastMatchStatus: number;

  constructor(tipId: number, tipsterInfo: FbTipsterInfo,  associateType: number, fbBetList: Array<FbBetModel>, packageTotalBetAmount: number
    , aMatchNum: number[], availableForPurchase: boolean, note: string, image: string
    , fbTipPrice: FbTipPrice, purchaseDate: string, fbNotes: FbNotes, currentBetAmount: number, buyerCount: number, allowRefund: boolean
    , addCommentEnabled: boolean, lastMatchNum: number, lastMatchDate: string, lastMatchStartTime: string
    , lastMatchStatus: number) {
    super(tipId, tipsterInfo, associateType, note, image, fbBetList, fbTipPrice, availableForPurchase, tipId, purchaseDate, -1, currentBetAmount, -1, allowRefund);
    this.packageTotalBetAmount = packageTotalBetAmount;
    this.aMatchNum = aMatchNum;
    this.fbNotes = fbNotes;
    this.buyerCount = buyerCount;
    this.addCommentEnabled = addCommentEnabled;
    this.lastMatchNum = lastMatchNum;
    this.lastMatchDate = lastMatchDate;
    this.lastMatchStartTime = lastMatchStartTime;
    this.lastMatchStatus = lastMatchStatus;
  }
}



// WEBPACK FOOTER //
// ./src/model/FbPersonalTipsPackage.ts